import "./zod.config";
import "./unistyles.config";
// Runs before the router entry: a cold in-car launch may never mount the tree.
import "./index.car";
import "expo-router/entry";
import { LogBox, Platform } from "react-native";

// We don't want to see the warnings on tvOS because it messes with the focus
if (Platform.isTV) {
  LogBox.ignoreAllLogs();
}
